import { useSettingsStore } from './useSettingsStore';

/**
 * Custom hook to get the URLSearchParams instance from the router settings.
 * This hook uses the `useSettingsStore` hook to access the state and retrieve the URLSearchParams instance.
 *
 * @returns {URLSearchParams} - Returns an instance of URLSearchParams.
 *
 * @example
 * const searchParams = useSearchParams();
 */
export function useSearchParams(): URLSearchParams {
  // Destructure the state from the useSettingsStore hook
  const { state } = useSettingsStore();

  // Return the URLSearchParams instance from the router settings
  return state.settings.router.useSearchParams();
}
